import { CATEGORY_ATTR, STAND_SECTOR_ATTR } from '../constants/ATTRS';
import { MIN_DISTANCE_FOR_START_DRAG } from '../constants/DISTANCES';

export function shouldDraggingStart(diffX: number, diffY: number) {
  return Math.max(Math.abs(diffX), Math.abs(diffY)) > MIN_DISTANCE_FOR_START_DRAG;
}

export function isSector(elem: HTMLElement) {
  return !!elem.getAttribute(STAND_SECTOR_ATTR);
}

export function isStandingSector(elem: HTMLElement) {
  // TODO: rewrite to data-* attributes
  return elem.getAttribute(STAND_SECTOR_ATTR) === 'true';
}

export function isCategory(elem: HTMLElement) {
  // TODO: rewrite to data-* attributes
  return elem.getAttribute(CATEGORY_ATTR) === 'true';
}
